var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00005 17.0761H13.0004C14.56 17.0761 15.3359 16.2851 15.3359 14.7181V7.87778H9.88159C8.9173 7.87778 8.46537 7.41814 8.46537 6.45385V0.924316H5.00005C3.44819 0.924316 2.66455 1.72274 2.66455 3.29003V14.7181C2.66455 16.2925 3.44819 17.0761 5.00005 17.0761ZM9.90441 6.84567H15.253C15.2003 6.53678 14.9817 6.23528 14.6278 5.86628L10.4692 1.64014C10.1227 1.27853 9.80637 1.05996 9.48977 1.00692V6.43907C9.48977 6.71003 9.63312 6.84567 9.90441 6.84567Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/Doc.8ec516b04c7e11dd82cf88606773cb9c.svg";
export { ForwardRef as ReactComponent };